module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-detail-bill"
  }, [_c('navbar', {
    attrs: {
      "title": "供货商对账单-明细"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "common-scroll detail-scroll"
  }, [_c('p', {
    staticClass: "detail-bill-status"
  }, [_vm._v("系统单号：" + _vm._s(_vm.returnDetailData.trans_bill_no) + "\n\t\t\t"), _c('span', {
    staticClass: "nav-btn",
    on: {
      "click": function($event) {
        return _vm.openBillInfo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/nav-btn.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.returnDetailData.bill_state == 0) ? _c('span', {
    staticClass: "state-grey-font"
  }, [_vm._v("未对账")]) : _vm._e(), _vm._v(" "), (_vm.returnDetailData.bill_state == 1) ? _c('span', {
    staticClass: "state-red-font"
  }, [_vm._v("已对账")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "detail-bill-organs"
  }, [_c('span', {
    staticClass: "detail-bill-organs-name"
  }, [_vm._v(_vm._s(_vm.returnDetailData.to_organ_name || '门店'))]), _vm._v(" "), _c('button', {
    staticClass: "detail-bill-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onSeeOrgansClick.apply(null, arguments)
      }
    }
  }, [_vm._v("查看")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-files"
  }, [(_vm.uploadDeliverFlag !== undefined && !_vm.isZ5) ? _c('div', {
    staticClass: "upload-file-div"
  }, [_c('label', [_vm._v("附件资料：")]), _vm._v(" "), _c('upload-img', {
    attrs: {
      "uploadImgState": _vm.uploadImgState,
      "uploadImgList": _vm.uploadImgList,
      "imgListLength": 3,
      "smallDelIco": _vm.smallDelIco,
      "billState": Number(_vm.returnDetailData.bill_state)
    },
    on: {
      "update:smallDelIco": function($event) {
        _vm.smallDelIco = $event
      },
      "attachDelPost": _vm.attachDelPost,
      "attachBeforeUpload": _vm.attachBeforeUpload,
      "attachClick": _vm.attachClick
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-files"
  }, [(_vm.uploadDeliverFlag !== undefined && !_vm.isZ5) ? _c('div', {
    staticClass: "upload-file-div"
  }, [_c('label', [_vm._v("PC附件资料：")]), _vm._v(" "), _c('upload-img', {
    attrs: {
      "uploadImgState": false,
      "uploadImgList": _vm.uploadImgListPC,
      "imgListLength": 3,
      "billState": Number(_vm.returnDetailData.bill_state)
    },
    on: {
      "update:smallDelIco": function($event) {
        _vm.smallDelIco = $event
      },
      "attachClick": _vm.attachClick
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bill-all-info bill-all-info-width"
  }, [_c('ul', {
    staticClass: "detail-bill-info-list bill-all-info-width"
  }, [_c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("业务日期：" + _vm._s(_vm.returnDetailData.from_date))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_c('div', {
    staticClass: "detail-bill-fulllist-left"
  }, [_vm._v("\n\t\t\t\t\t\t明细数：" + _vm._s(_vm._f("numFixed2")(_vm.returnDetailData.bill_dt_count, 4)) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-fulllist-right detail-bill-items-link",
    on: {
      "click": _vm.onDtItems
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("非税金额：" + _vm._s(_vm._f("numFixed2")(_vm.returnDetailData.instore_sum_money, 4)))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("含税金额：" + _vm._s(_vm._f("numFixed2")(_vm.returnDetailData.include_tax_sum_money, 4)))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("备注：" + _vm._s(_vm.returnDetailData.remark))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "detail-bill-footer"
  }, [(_vm.buttonState && _vm.returnDetailData.bill_state != 1) ? _c('div', {
    staticClass: "detail-bill-return f-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.agreen('1')
      }
    }
  }, [_vm._v("同意")])]) : _vm._e(), _vm._v(" "), (_vm.buttonState && _vm.returnDetailData.bill_state != 1) ? _c('div', {
    staticClass: "detail-bill-red f-right"
  }, [_c('a', {
    on: {
      "click": _vm.refuseB
    }
  }, [_vm._v("退回")])]) : _vm._e()]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsB),
      expression: "tipsB"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatusB
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsOrgans),
      expression: "tipsOrgans"
    }],
    attrs: {
      "btnNum": _vm.btnNum1,
      "tipsFont": _vm.tipsFontOrgans
    },
    on: {
      "tipStatus": _vm.tipStatusOrgan
    }
  }), _vm._v(" "), _c('item-img', {
    ref: "itemImgRef"
  }), _vm._v(" "), _c('dt-items', {
    ref: "dtItemsRef",
    attrs: {
      "restaurantId": _vm.restaurantId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-624ac9f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierAccountCheckDetailBill.vue
// module id = 579
// module chunks = 1